import { InvoiceStatusEnum, InvoiceSummaryResp } from '@monetize/types/app';
import { DEFAULT_PAGER } from '@monetize/types/common';
import hasValue from 'lodash/has';
import { useInvoiceListByAccount } from '../../api/accountsService';
import { getInvoiceDaysPastDue } from '../../utils/invoices';
import { arrayToObjects } from '../../utils/misc';

export const useAccountPastDueInformation = (
  accountId: string,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const { isLoading, data: groupedAmountDue = {} } = useInvoiceListByAccount(
    {
      accountId,
      config: { ...DEFAULT_PAGER, rows: 300 },
      filters: {
        status: InvoiceStatusEnum.UNPAID,
        amount: {
          between: {
            gte: 0,
          },
        },
      },
    },
    {
      enabled,
      select: ({ content }) => {
        const now = new Date();
        const pastDueContents = content.filter(
          ({ dueDate }) => getInvoiceDaysPastDue(dueDate, now) > 0,
        );
        const aggregatedData: Record<string, number> = {};
        const groupedData = arrayToObjects<InvoiceSummaryResp>(
          pastDueContents,
          'billGroupId',
        );
        for (const key in groupedData) {
          if (key in groupedData) {
            aggregatedData[key] = groupedData[key].reduce(
              (acc, obj) => acc + obj.amountDue,
              0,
            );
          }
        }
        return aggregatedData;
      },
      meta: { showErrorToast: true },
    },
  );

  const getDueAmountByBillGroupId = (billGroupId: string) => {
    return hasValue(groupedAmountDue, billGroupId)
      ? groupedAmountDue[billGroupId]
      : 0;
  };

  return {
    isLoading,
    groupedAmountDue,
    totalAmountDue: Object.values(groupedAmountDue).reduce(
      (acc, val) => acc + val,
      0,
    ),
    getDueAmountByBillGroupId,
  };
};
